(function ($) {
  'use strict';

  /**
   * @param $element   jQuery object to be copied
   * @constructor
   */
  this.WLCClipboard = function ($element) {
    if ($element.length < 1) {
      console.log('No element supplied to WLCClipboard');
    }

    this.$element = $element;

    this.$temp = null;

    var el = $element.get(0);

    if (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA') {
      // We need a new temporary input element to use
      this.$temp = $(
        '<textarea style="opacity:0;position:absolute;">' +
          el.textContent +
          '</textarea>'
      );
      $('body').append(this.$temp);
    }
  };

  this.WLCClipboard.prototype.copy = function () {
    var success;
    var currentFocus = document.activeElement;

    var $target = this.$temp ? this.$temp : this.$element;
    var $targetValue = $target.val();

    $target.focus().select();

    navigator.clipboard
      .writeText($targetValue)
      .then(function () {
        success = true;
      })
      .catch(function () {
        success = false;
      });

    // Restore original focus
    if (currentFocus && typeof currentFocus.focus === 'function') {
      currentFocus.focus();
    }

    if (this.$temp) {
      this.$temp.remove();
      this.$temp = null;
    }

    return success;
  };
}).bind(window)(jQuery);
